import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiEventHubPluginKey: PluginKey = new PluginKey('aiEventHub');
